import { BlockchainType } from '../../types/services/enums';
import { ChainId } from '../config/networks';
/**
 * Checks if the given network is an EVM (Ethereum Virtual Machine) compatible network.
 *
 * @param network - The network identifier to check.
 * @returns `true` if the network is an EVM network, otherwise `false`.
 */
export const isEVMNetwork = (network) => {
    return !(network == ChainId.SOLANA ||
        network == ChainId.SOLANA_DLN ||
        network == ChainId.SOLANA_OKX ||
        network == ChainId.SUI || network == ChainId.APTOS);
};
export const isSuiNetwork = (network) => {
    return network === ChainId.SUI;
};
/**
 * Checks if the given network is a Solana network.
 *
 * @param network - The network to check, represented by a ChainId.
 * @returns `true` if the network is Solana, Solana DLN, or Solana OKX; otherwise, `false`.
 */
export const isSolanaNetwork = (network) => {
    return (network == ChainId.SOLANA || network == ChainId.SOLANA_DLN || network == ChainId.SOLANA_OKX);
};
export const isSui = (network) => {
    return network === ChainId.SUI;
};
export const determineVMType = (network) => {
    if (isEVMNetwork(network)) {
        return BlockchainType.EVM;
    }
    else if (isSolanaNetwork(network)) {
        return BlockchainType.SVM;
    }
    else if (isSui(network)) {
        return BlockchainType.MOVE;
    }
    else {
        return BlockchainType.UNKNOWN;
    }
};
export const determineTXType = (transactions) => {
    const isJsonString = (str) => {
        try {
            JSON.parse(str);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    // Extract first transaction with more explicit logic
    const getFirstTransaction = (txs) => {
        var _a, _b;
        if (Array.isArray(txs))
            return txs[0];
        if ((_a = txs === null || txs === void 0 ? void 0 : txs.swap) === null || _a === void 0 ? void 0 : _a[0])
            return txs.swap[0];
        if ((_b = txs === null || txs === void 0 ? void 0 : txs.withdraw) === null || _b === void 0 ? void 0 : _b[0])
            return txs.withdraw[0];
        return txs;
    };
    const firstTx = getFirstTransaction(transactions);
    console.log('LOGG firstTx', firstTx);
    if (!firstTx)
        return BlockchainType.UNKNOWN;
    // Determine type using type guards
    if (typeof firstTx === 'object')
        return BlockchainType.EVM;
    if (typeof firstTx !== 'string')
        return BlockchainType.UNKNOWN;
    return isJsonString(firstTx) ? BlockchainType.MOVE : BlockchainType.SVM;
};
export const determineOrderString = (orderType, // Restrict orderType to valid values
vmType, isSponsored) => {
    const networkTypeMap = {
        [BlockchainType.EVM]: 'EVM',
        [BlockchainType.SVM]: 'SOLANA',
        [BlockchainType.MOVE]: 'SUI',
        [BlockchainType.UNKNOWN]: 'UNKNOWN',
    };
    const networkType = networkTypeMap[vmType];
    if (networkType === 'UNKNOWN') {
        throw new Error('Invalid network to determine action type');
    }
    // Create the string and assert it as GeniusOrderType
    return `${orderType}_${networkType}${isSponsored ? '_SPONSORED' : ''}`;
};
export const getVMTypeFromOrderType = (orderType) => {
    if (orderType.includes('SUI'))
        return BlockchainType.MOVE;
    if (orderType.includes('SOLANA'))
        return BlockchainType.SVM;
    if (orderType.includes('EVM'))
        return BlockchainType.EVM;
    return BlockchainType.UNKNOWN;
};
